export { dashboardTableFeatures } from './table-features';
export type { DashboardTableFeatures } from './table-features';

/**
 * Zentrale Konfiguration der Dashboard-App.
 * Alle Werte werden aus Umgebungsvariablen gelesen.
 */
export const config = {
  apiUrl: import.meta.env.VITE_API_URL ?? 'https://api.fanini.live/api',
  appTitle: import.meta.env.VITE_APP_TITLE ?? 'Fanini Dashboard',
  clerkPublishableKey: import.meta.env.VITE_CLERK_PUBLISHABLE_KEY ?? '',
} as const;
